import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu'
import { FaFacebookF, FaInstagram } from 'react-icons/fa'
import '@szhsin/react-menu/dist/index.css'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink, useLocation } from 'react-router-dom'
import UserIcon from '../../assets/images/account.svg'
import Logo from '../../assets/images/logo.png'
import { showPhoneVerificationModalHandler } from '../../store/profile-data.slice'
import { StoreInterface } from '../../store/store'
import Button from '../Button/Button'
import CommonModal from '../Modal/Modal'
import Signup from '../Signup/Signup'
import { NavLinks } from './Header.constants'
import style from './Header.module.scss'
import PhoneVerification from '../PhoneVerification'
import { AxiosService } from '../../services/axios.service'

const Header = () => {
  const { profile, showPhoneVerificationModal } = useSelector((store: StoreInterface) => {
    return store.profile
  })
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const isHomePage = pathname === '/'

  const [isNavDrawerOpen, setIsNavDrawerOpen] = useState(false)
  const [sticky, setSticky] = useState(isHomePage ? false : true)
  const [signupModal, setSignupModal] = useState<boolean>(false)

  const closeNavDrawer = useCallback(() => setIsNavDrawerOpen(false), [])
  // const toggleNavDrawer = useCallback(
  //   () => setIsNavDrawerOpen((value) => !value),
  //   []
  // ); // Unused function

  const logout = () => {
    const axiosService = AxiosService.getInstance()
    axiosService.clearTokens()
    window.location.href = '/'
  }

  const closePhoneVerificationModal = () => {
    dispatch(showPhoneVerificationModalHandler(false))
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const closeLoginModal = () => {
    dispatch(showPhoneVerificationModalHandler(false))
  }

  const closeSignupModal = () => {
    setSignupModal(false)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const showSignup = () => {
    dispatch(showPhoneVerificationModalHandler(false))
    setSignupModal(true)
  }

  const showLogin = () => {
    dispatch(showPhoneVerificationModalHandler(true))
    setSignupModal(false)
  }

  useEffect(() => {
    if (pathname === '/') {
      setSticky(true)
    } else {
      setSticky(false)
    }
  }, [pathname])

  useEffect(() => {
    if (isNavDrawerOpen) {
      document.body.classList.add('disableScroll')
    } else {
      document.body.classList.remove('disableScroll')
    }
  }, [isNavDrawerOpen])

  window.addEventListener('scroll', () => {
    if (!isHomePage) return

    const scrollTop = window.scrollY
    if (scrollTop >= 20) {
      setSticky(true)
    } else {
      setSticky(false)
    }
  })
  return (
    <>
      <header
        className={`${style.header} ${sticky && style.isSicky} ${isHomePage ? '' : style.isHomePage}`}
      >
        <div className="container flex-wrap align-center justify-between">
          <NavLink className={style.header__logo} to="/">
            <img src={Logo} alt="Chauffeur Rides" />
          </NavLink>

          <div className={`${style.header__nav} ${isNavDrawerOpen ? style.isActive : ''}`}>
            <nav>
              {NavLinks.map(item => (
                <Link key={item.href} to={item.href} onClick={closeNavDrawer}>
                  {item.title}
                </Link>
              ))}
            </nav>

            <div className={style.header__socialIcons}>
              <a
                href="https://www.instagram.com/chauffeurridesltd"
                target="_blank"
                rel="noreferrer"
                className={style.header__socialIcon}
              >
                <FaInstagram />
              </a>

              <a
                href="https://www.facebook.com/share/1KdCw5uBJj/"
                target="_blank"
                rel="noreferrer"
                className={style.header__socialIcon}
              >
                <FaFacebookF />
              </a>
            </div>

            {!profile && (
              <Button label={'Login'} buttonType="secondary sm" onClick={() => showLogin()} />
            )}
          </div>

          {profile && (
            <Menu
              menuButton={
                <MenuButton className={`${style.header__user} flex align-center`}>
                  <img src={UserIcon} alt="User" />
                  <span>{profile.firstName + ' ' + profile.lastName}</span>
                </MenuButton>
              }
              arrow={true}
            >
              <MenuItem>
                <Link to="/bookings">Bookings</Link>
              </MenuItem>

              <MenuItem onClick={logout}>
                <span className={style.header__user__logout}>Logout</span>
              </MenuItem>
            </Menu>
          )}
          <div
            className={`${style.header__hamburger} ${isNavDrawerOpen && style.isActive}`}
            onClick={() => setIsNavDrawerOpen(!isNavDrawerOpen)}
          >
            <span></span>
          </div>

          <div
            className={`${style.header__overlay} ${isNavDrawerOpen ? style.isActive : ''}`}
            onClick={closeNavDrawer}
          ></div>
        </div>
      </header>

      <PhoneVerification
        isOpen={showPhoneVerificationModal}
        onClose={closePhoneVerificationModal}
      />

      <CommonModal
        modalWidth={'500px'}
        open={signupModal}
        title={'Create account'}
        onCloseModal={closeSignupModal}
      >
        <Signup showLogin={showLogin} />
      </CommonModal>
      <div className={`${style.header__holder} ${sticky && style.isSicky}`}></div>
    </>
  )
}
export default Header
